export const purchasesEn = {
  title: 'Purchases',
  create: 'New Purchase',
  loading: 'Loading...',
  emptyTitle: 'No purchase orders',
  emptyDesc: 'You have not created any purchase orders yet',
  emptyAction: 'Create first purchase',
  columns: {
    number: 'Purchase No.',
    title: 'Title',
    amount: 'Amount',
    status: 'Status',
    createdAt: 'Created At',
    actions: 'Actions',
  },
  actions: {
    view: 'View',
  },
  status: {
    DRAFT: 'Draft',
    PENDING: 'Pending',
    APPROVED: 'Approved',
    RECEIVED: 'Received',
    REJECTED: 'Rejected',
  },
};

export type PurchasesTranslations = typeof purchasesEn;
